import React from 'react';

import { Switch, Route } from "react-router-dom";


import AdminUsers from './pages/Admin/Users'
import AdminUserForm from './pages/Admin/Users/user'
import BenefitAdmin from './pages/Admin/Benefits/index'
import FormBenefitAdmin from './pages/Admin/Benefits/form'
import SalarySettlementAdmin from './pages/Admin/SalarySettlement'

import AdminParams from './pages/Admin/Params/index'


import UsersAdminState from './context/Admin/Users/UsersAdminState';
import SalarySettlementState from './context/SalarySettlement/SalarySettlementState';

const RouterAdmin = () => {
    return ( 
        <UsersAdminState>
            <Switch>
                <Route exact path="/admin/user" component={AdminUsers}/>
                <Route exact path="/admin/user/form" component={AdminUserForm}/>  
                <Route exact path="/admin/benefit" component={BenefitAdmin}/>    
                <Route exact path="/admin/benefit/form" component={FormBenefitAdmin}/>   
                <Route exact path="/admin/salarySettlement">  
                    <SalarySettlementState> <SalarySettlementAdmin/> </SalarySettlementState>
                </Route>
                <Route exact path="/admin/params" component={AdminParams}/>   
            </Switch> 
        </UsersAdminState>
     );
}
 //salarySettlement
export default RouterAdmin;